module.exports = __webpack_public_path__ + "media/images/favicon-1-916ee6dfe192979424e7813a73e521f0.png";